import { BoxProps } from '@material-ui/core';
import { CheckoutSessionStatus } from '@nemuru-eng/js-api-client';

import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { StatusTagType } from '@/config/types';

interface ApplicationStatusChipProps {
  checkoutSessionStatus: CheckoutSessionStatus;
  boxProps?: BoxProps;
}

const STATUS_TAG_TYPE: Record<CheckoutSessionStatus, StatusTagType> = {
  [CheckoutSessionStatus.INITIAL]: StatusTagType.DEFAULT,
  [CheckoutSessionStatus.CHALLENGE]: StatusTagType.WARNING,
  [CheckoutSessionStatus.CONFIRMED]: StatusTagType.SUCCESS,
  [CheckoutSessionStatus.DENIED]: StatusTagType.ERROR,
  [CheckoutSessionStatus.CANCELLED]: StatusTagType.DEFAULT,
  [CheckoutSessionStatus.DESISTED]: StatusTagType.DEFAULT,
  [CheckoutSessionStatus.EXPIRED]: StatusTagType.DEFAULT,
};

const COLOR_TYPE: Record<CheckoutSessionStatus, 'main' | 'light' | 'dark'> = {
  [CheckoutSessionStatus.INITIAL]: 'dark',
  [CheckoutSessionStatus.CHALLENGE]: 'main',
  [CheckoutSessionStatus.CONFIRMED]: 'main',
  [CheckoutSessionStatus.DENIED]: 'main',
  [CheckoutSessionStatus.CANCELLED]: 'light',
  [CheckoutSessionStatus.DESISTED]: 'main',
  [CheckoutSessionStatus.EXPIRED]: 'light',
};

export const ApplicationStatusChip = ({ checkoutSessionStatus }: ApplicationStatusChipProps) => {
  const type = STATUS_TAG_TYPE[checkoutSessionStatus];
  const colorType = COLOR_TYPE[checkoutSessionStatus];

  return <StatusTag type={type} labelTextId={checkoutSessionStatus} colorType={colorType} />;
};
